import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { SubEntitiesProjectType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { SUBENTITIES_PROJECTS } from "../../utils/constants";

export const createSubEntitiesProject = async (data: SubEntitiesProjectType) => await post<SubEntitiesProjectType, string>(SUBENTITIES_PROJECTS, data);
export const updateSubEntitiesProject = async (data: SubEntitiesProjectType) => await put<SubEntitiesProjectType, string>(SUBENTITIES_PROJECTS, data);

export const getSubEntitiesProject = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdSubEntity ? { IdSubEntity: data.IdSubEntity } : {}),
        ...(data?.IdProject ? { IdProject: data.IdProject } : {}),

    });
    const url = `${SUBENTITIES_PROJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<SubEntitiesProjectType>>(url);
};
